<template>
    <Card
        :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`"
        :newLayout="true"
        :hideFooter="false"
        :hideHeader="true"
    >
        <template slot="card-body">
            <div class="row justify-content-center text-size-base mb-3">
                <div class="col-md-8 text-center">
                    <div class="card-header__icon mt-4">
                        <svg-rndr
                            :width="163"
                            svg="check-circle-green.svg"
                        />
                    </div>
                    <h1
                        class="text-white mb-3"
                        v-translate='{firstName: user.first_name}'
                    >Congratulations, %{ firstName }</h1>
                    <p
                        class="text-standard"
                        v-translate
                    >You've enrolled SmartCharts.</p>
                    <template v-if="Object.keys(payment).length">
                        <p
                            class="text-standard"
                            v-if='payment.subscription.months > 0'
                            v-translate='{price: payment.price, product: payment.subscription.name, cardNumber: payment.card.number, cardType: payment.card.type, freq: paymentFrequency}'
                        >
                            The first %{ freq } subscription payment of $%{ price } for %{ product } with %{ cardType } **** %{ cardNumber } was made successfully.
                        </p>
                        <p
                            class="text-standard"
                            v-else
                            v-translate='{price: payment.price, product: payment.subscription.name, cardNumber: payment.card.number, cardType: payment.card.type, freq: paymentFrequency}'
                        >
                            A payment of $%{ price } for %{ product } with %{ cardType } **** %{ cardNumber } was made successfully.
                        </p>
                    </template>
                </div>
            </div>
        </template>
        <template slot="card-footer">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <flash-message></flash-message>
                </div>
            </div>
            <div class="row justify-content-end">
                <div class="col-auto text-center">
                    <button
                        @click="complete"
                        class="btn btn-primary"
                        v-translate
                    >Continue</button>
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import Card from '@C/Card.vue';
import FlashMessage from '@C/FlashMessage';
import EnrolmentMixin from '@M/enrolment.js';
import { mapActions, mapState, mapMutations } from 'vuex';
import { paymentFrequencyForPurchaseOption } from '@H/enrolment';

export default {
    name: 'Success',
    created() {
        this.tracking();
    },
    props: {
        complete: {
            type: Function,
            required: true
        },
        payment: {
            type: Object,
            required: true
        },
        user: {
            type: Object,
            required: true
        }
    },
    components: {
        Card,
        FlashMessage
    },
    computed: {
        ...mapState('Flash', ['flash']),
        paymentFrequency() {
            return paymentFrequencyForPurchaseOption(this.payment.subscription.months);
        }
    },
    methods: {
        /**
         * Track the purchase in LeadDyno
         */
        tracking() {
            if (!window.ENV.LEAD_DYNO_KEY.length) {
                return;
            }
            LeadDyno.key = window.ENV.LEAD_DYNO_KEY;
            LeadDyno.recordPurchase();
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Enrolment/Success.vue